import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TchatRoom } from '../../../models/server/tchat-room';
import { TchatUser } from '../../../models/server/tchat-user';
import { TchatRoomMessageComponent } from '../tchat-room-message/tchat-room-message.component';

@Component({
    selector: 'app-tchat-room-messages',
    templateUrl: './tchat-room-messages.component.html',
    styleUrls: ['./tchat-room-messages.component.scss'],
    imports: [TchatRoomMessageComponent]
})
export class TchatRoomMessagesComponent {
    /**
     * Valeur indiquant si il s'agit d'un tchat en live (true) ou de l'historique d'un tchat (false).
     */
    @Input()
    public isLiveTchat: boolean;

    /**
     * Utilisateur à l'origine de la conversation.
     */
    @Input()
    public sourceUser: TchatUser;

    /**
     * Conversation courante.
     */
    @Input()
    public set room(room: TchatRoom) {
        this._room = room;

        setTimeout(() => {
            if (this.isLiveTchat) {
                if (room.messages.length !== 0) {
                    this.scrollingContainer.nativeElement.scrollTop = this.scrollingContainer.nativeElement.scrollHeight;
                }
            }
        }, 250);
    }

    public get room(): TchatRoom {
        return this._room;
    }

    private _room: TchatRoom;

    @ViewChild('scrollingContainer', { static: false })
    scrollingContainer: ElementRef;

    /**
     * Date du jour.
     * Utilisé pour déterminer le format d'affichage des dates.
     */
    public currentDate: Date = new Date();

    /**
     * Constructeur.
     */
    constructor() {}
}
